import EstensaModel from 'estensa-module';
import { CustomPageType } from '@se/platform';

export interface Typology {
    code: EstensaModel.BrokerTypeFilter;
    examDescription: string;
    studyDescription: string;
}

export interface BrokerTableDataDisplayBase {
    cognome: string;
    nome: string;
    sesso: string;
    description: string;
}
export interface BrokerTableDataDisplay extends BrokerTableDataDisplayBase {
    patientBirthDateFormatted: string;
}
export interface BrokerExtendedTableDataDisplay extends BrokerTableDataDisplayBase {
    status?: string;
    dataNascita: string | Date;
    date: string | Date;
    modality: string;
    inBroker: Date;
    exam: EstensaModel.BrokerDataExam;
}

export enum BrokerAssociationStatus {
    DEFAULT = '',
    ASSOCIABLE = 'ValidableAssociation',
    VALIDATED = 'ValidatedAssociation',
    MODIFIED = 'ModifiedData',
    ARCHIVED = 'Archived',
}

export interface BrokerExamIdsAndCustomPageType {
    examinationIds: string[];
    customPageType: CustomPageType | undefined | null;
}

export enum BrokerModalsActions {
    YES = 'Yes',
    OK = 'Ok',
    NO = 'No',
    CANCEL = 'Cancel', // 'Undo' or 'Close' in translationService
}
